/**
 * Защита от повторных переходов на подписание ЭЦП.
 *
 * Клиент нажимает «Перейти к подписанию», уходит на страницу Aitu, не дожидается
 * кода и возвращается кнопкой «назад». Страница загружается заново, кнопка снова
 * активна — он жмёт ещё раз, и каждое нажатие для Aitu это новый запрос кода.
 * 19.10.2026 по одной ссылке набегало 3-4 перехода за 17 секунд, после чего
 * сервис подписания отвечал «слишком много запросов кода» и клиент не мог
 * подписать вовсе.
 *
 * Поэтому момент перехода запоминаем в браузере клиента и минуту держим кнопку
 * закрытой, показывая отсчёт.
 */

/** Сколько ждать до следующего перехода. Код от Aitu обычно приходит за минуту. */
export const ECP_RESEND_SECONDS = 60;

const KEY_PREFIX = 'ecp-sign-started:';

export const storageKey = (signUrl) => `${KEY_PREFIX}${signUrl ?? ''}`;

/**
 * Сколько секунд осталось ждать. 0 — переходить можно.
 * Время в будущем (часы на телефоне перевели) не держит клиента: лучше пропустить
 * лишний переход, чем запереть подписание до конца суток.
 */
export const secondsLeft = (startedAt, now = Date.now(), timeout = ECP_RESEND_SECONDS) => {
  const started = Number(startedAt);
  if (!startedAt || Number.isNaN(started)) return 0;
  const passed = Math.floor((now - started) / 1000);
  if (passed < 0) return 0;
  const left = timeout - passed;
  return left > 0 ? left : 0;
};

/** Отсчёт для клиента: 0:47. */
export const formatLeft = (seconds) => {
  const safe = seconds > 0 ? seconds : 0;
  const min = Math.floor(safe / 60);
  const sec = safe % 60;
  return `${min}:${String(sec).padStart(2, '0')}`;
};

/** Хранилище может быть недоступно (приватный режим) — тогда просто не держим. */
export const readStartedAt = (signUrl, storage) => {
  try {
    return (storage || window.localStorage).getItem(storageKey(signUrl));
  } catch (e) {
    return null;
  }
};

export const rememberStart = (signUrl, now = Date.now(), storage) => {
  try {
    (storage || window.localStorage).setItem(storageKey(signUrl), String(now));
  } catch (e) {
    // приватный режим или переполнение — переход всё равно разрешаем
  }
};
